import { useNavigate } from 'react-router-dom';
import { Tile, Tag, Button } from '@carbon/react';
import { Document, Receipt, ArrowRight, Add } from '@carbon/icons-react';
import { useAuth } from '@/contexts/AuthContext';
import DocumentTracker from '@/components/DocumentTracker';

const quickActions = [
  {
    title: 'Create contract',
    description: 'Generate NDAs and service agreements, then send for e-signature.',
    to: '/contracts',
    icon: Document,
    cta: 'New contract',
  },
  {
    title: 'Create invoice',
    description: 'Build invoices and share payment links with clients.',
    to: '/invoices',
    icon: Receipt,
    cta: 'New invoice',
  },
];

const DashboardPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="dashboard-page" data-testid="dashboard-page">
      <div className="section-header">
        <Tag type="blue">DASHBOARD</Tag>
        <h2 className="section-title">Welcome, {user?.name || 'User'}</h2>
        <p className="section-description">
          Manage contracts, invoices, and shared client documents from your workspace.
        </p>
      </div>

      <div className="dashboard-quick-actions">
        {quickActions.map(({ title, description, to, icon: Icon, cta }) => (
          <Tile key={to} className="dashboard-action-tile">
            <div className="dashboard-action-tile__icon">
              <Icon size={24} />
            </div>
            <h3 className="dashboard-action-tile__title">{title}</h3>
            <p className="dashboard-action-tile__description">{description}</p>
            <Button
              kind="primary"
              size="sm"
              renderIcon={Add}
              onClick={() => navigate(to)}
            >
              {cta}
            </Button>
          </Tile>
        ))}
      </div>

      <DocumentTracker />

      <div className="dashboard-footer-actions">
        <Button kind="ghost" renderIcon={ArrowRight} onClick={() => navigate('/contracts')}>
          View all contracts
        </Button>
        <Button kind="ghost" renderIcon={ArrowRight} onClick={() => navigate('/invoices')}>
          View all invoices
        </Button>
      </div>
    </div>
  );
};

export default DashboardPage;
